export default "__VITE_PUBLIC_ASSET__8cd34574__"